export default __webpack_public_path__ + "static/2163-bded16ebdf15e79ce8728b9204bf6560.gif";